{
  "memoryOwner.knowledge.items": "Knowledge items",
  "memoryOwner.knowledge.archive": "Archive",
  "memoryOwner.knowledge.archived": "Knowledge item archived",
  "memoryOwner.knowledge.archived_description": "It remains available in Archive and can be restored with its relations intact.",
  "memoryOwner.related.title": "Related memory",
  "memoryOwner.related.description": "Records that share explicit project, relation, or life context with this note.",
  "memoryOwner.related.refresh": "Refresh",
  "memoryOwner.related.load_error": "Related memory could not be loaded",
  "memoryOwner.related.load_error_description": "Refresh the explicit connections and try again.",
  "memoryOwner.related.empty": "No related records yet",
  "memoryOwner.related.empty_description": "Add a project or a relation to this note; records in the same explicit context will appear here.",
  "memoryOwner.related.results": "Related records",
  "memoryOwner.related.untitled": "Untitled record",
  "memoryOwner.related.type.note": "Note",
  "memoryOwner.related.type.moment": "Moment",
  "memoryOwner.related.type.draft": "Draft",
  "memoryOwner.related.type.life_item": "Life record",
  "memoryOwner.related.type.decision": "Decision",
  "memoryOwner.related.type.focus": "Focus session"
}
